import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { useSite } from '../../context/SiteProvider.jsx';
import { Header, Topbar, Footer, FloatingActions } from './Header.jsx';
import { CartDrawer, CustomerModal } from './CartDrawer.jsx';
import { PageLoader } from '../common/Skeletons.jsx';

/** Routes start at the top; in-page anchors keep the browser's own behaviour. */
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}

export function SiteLayout() {
  const { isLoading, isError, refetch, t } = useSite();
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);

  if (isLoading) return <PageLoader label="Connix" />;

  if (isError) {
    return (
      <div className="boot-error">
        <h1>Connix</h1>
        <p>Cannot reach the Connix API. Is the server running?</p>
        <button className="button dark" type="button" onClick={() => refetch()}>
          <span>Try again</span>
          <span>↗</span>
        </button>
      </div>
    );
  }

  return (
    <>
      <ScrollToTop />
      <a className="skip-link" href="#main">{t('skipToContent')}</a>
      <Topbar />
      <Header />
      <Outlet />
      <Footer />
      <FloatingActions />
      <CartDrawer onCheckout={() => setIsCheckoutOpen(true)} />
      <CustomerModal isOpen={isCheckoutOpen} onClose={() => setIsCheckoutOpen(false)} />
    </>
  );
}
